import type { SxProps, Theme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';

type Props = {
	sx?: SxProps<Theme>;
};

export const MissingHcpIcon = ({ sx }: Props) => {
	return (
		<SvgIcon width='94' height='86' viewBox='0 0 94 86' fill='none' sx={sx}>
			<path
				d='M14.3916 75.7471L32.2695 57.8796L28.1709 53.7822L10.3073 71.6622L14.3916 75.7471Z'
				fill='#0057B2'
			/>
			<path
				d='M5.48748 84.7223L19.1964 71.0146C20.3408 69.8671 20.3408 68.0025 19.1964 66.855C18.0514 65.7137 16.1861 65.7137 15.0411 66.855L1.33277 80.5689C0.187763 81.7102 0.187763 83.5748 1.33277 84.7223C2.47716 85.8636 4.34309 85.8636 5.48748 84.7223Z'
				fill='#0057B2'
			/>
			<path
				d='M19.1064 62.4365C18.9707 62.3002 18.7395 62.2873 18.5771 62.4404L0.942383 80.0742C0.804217 80.2143 0.794944 80.4467 0.951172 80.6084L5.44824 85.1055C5.6106 85.2591 5.8417 85.2468 5.97754 85.1104L23.6152 67.4727C23.7526 67.3337 23.7639 67.1031 23.6113 66.9414L19.1064 62.4365Z'
				fill='#90CAF9'
				stroke='#1565C0'
				strokeWidth='1.37234'
			/>
			<path
				d='M51.8311 1.00391C33.5131 1.00408 18.6555 15.8631 18.6553 34.1934C18.6553 52.5298 33.5126 67.3836 51.8447 67.3838C70.1628 67.3838 85.0205 52.5116 85.0205 34.1934C85.0203 15.8632 70.1631 1.00391 51.8311 1.00391ZM51.8311 5.89258C67.2427 5.89258 79.708 18.5644 79.708 34.1816C79.7078 49.7983 67.2429 62.4824 51.8311 62.4824C36.4335 62.4822 23.9541 49.8107 23.9541 34.1934C23.9543 18.5768 36.4193 5.89275 51.8311 5.89258Z'
				fill='#42A5F5'
				stroke='#1565C0'
				strokeWidth='1.37234'
			/>
			<circle
				cx='30.4203'
				cy='30.4203'
				r='30.4203'
				transform='matrix(-1 0 0 1 82.3867 3.62402)'
				fill='white'
			/>
			<mask
				id='mask0_5627_65493'
				maskUnits='userSpaceOnUse'
				x='26'
				y='8'
				width='53'
				height='52'
			>
				<circle cx='52.2111' cy='34.0441' r='25.8458' fill='#D9D9D9' />
			</mask>
			<g mask='url(#mask0_5627_65493)'>
				<circle
					cx='76.4558'
					cy='55.0867'
					r='50.0906'
					fill='#E3F2FD'
					fillOpacity='0.8'
				/>
			</g>
			<mask
				id='mask1_5627_65493'
				maskUnits='userSpaceOnUse'
				x='21'
				y='3'
				width='62'
				height='62'
			>
				<circle
					cx='52.2113'
					cy='34.0443'
					r='30.4203'
					fill='white'
					fillOpacity='0.8'
				/>
			</mask>
			<g mask='url(#mask1_5627_65493)'>
				<path
					d='M20.7178 1.00391H83.7334C83.7436 1.00391 83.8918 1.0126 84.1406 1.36914C84.3773 1.70835 84.6175 2.24596 84.8301 2.97559C85.2526 4.42581 85.5215 6.48056 85.5215 8.80859V58.376C85.4882 60.3432 85.2366 62.0727 84.8672 63.3408C84.6548 64.0699 84.4133 64.6097 84.1787 64.9512C84.0622 65.1207 83.9626 65.2193 83.8906 65.2705C83.8565 65.2947 83.8329 65.3051 83.8203 65.3096C83.8142 65.3117 83.8104 65.3132 83.8086 65.3135H20.7178C20.7045 65.3132 20.5575 65.2998 20.3115 64.9473C20.0748 64.608 19.8337 64.0705 19.6211 63.3408C19.1986 61.8905 18.9307 59.8356 18.9307 57.5078V8.80859C18.9307 6.48066 19.1986 4.4258 19.6211 2.97559C19.8337 2.24596 20.0749 1.70835 20.3115 1.36914C20.5573 1.01704 20.7044 1.00417 20.7178 1.00391Z'
					fill='white'
					stroke='#1565C0'
					strokeWidth='1.37234'
				/>
				<path
					d='M73.9263 33.1047C73.9263 39.5828 70.9817 45.4715 66.5648 49.5938C62.7369 53.1273 57.4367 55.1889 51.842 55.1889C46.2474 55.1889 40.9471 53.1273 37.1192 49.5938C32.4079 45.4715 29.7578 39.5828 29.7578 33.1047C29.7578 21.032 39.7693 11.0205 51.842 11.0205C63.9147 11.0205 73.9263 21.032 73.9263 33.1047Z'
					fill='#BBDEFB'
				/>
				<path
					d='M66.5648 49.5635C62.7368 53.097 57.4366 55.1586 51.842 55.1586C46.2473 55.1586 40.9471 53.097 37.1191 49.5635C38.8859 48.9746 40.9471 48.0916 43.5972 46.9137C44.1861 46.6193 44.775 46.0304 45.0695 45.4414C45.3639 45.147 45.3639 44.5576 45.3639 44.2632V38.6688L45.0695 38.3741C44.4805 37.7852 44.1861 36.9024 44.1861 36.019L43.5972 35.7242C42.1249 36.0187 42.4194 34.5467 41.8305 31.6021C41.8305 30.4243 41.8305 30.1296 42.4194 29.8351L43.0083 29.2464C40.3582 23.0628 41.536 19.2344 44.4805 17.7621C43.5972 15.7009 43.5972 15.1123 43.5972 15.1123C43.5972 15.1123 49.4863 15.9955 51.2531 15.7011C53.9032 15.1122 57.7311 15.7009 59.2034 19.2344C61.559 20.1178 62.4424 21.5905 62.7368 23.3572C63.0313 26.0073 61.559 28.9518 61.2645 29.8351C61.559 30.1296 61.8535 30.424 61.559 31.3074C61.2646 33.9575 61.2645 35.724 59.7923 35.4295L58.6145 37.7853C58.6145 38.0798 58.6145 38.0796 58.6145 38.3741C58.6145 38.6685 58.6145 39.5519 58.6145 44.2632C58.6145 44.8521 58.9089 45.441 58.9089 45.7355C59.2034 46.3244 59.7923 46.6193 60.0867 46.9137C62.7368 48.386 64.798 48.9746 66.5648 49.5635Z'
					fill='white'
				/>
				<path
					d='M61.3367 30.1289C61.3367 29.5105 61.0305 28.5971 60.7243 27.9787V27.6552C59.4993 25.2112 57.0465 24.298 54.5937 24.298C48.4661 23.9741 47.8506 25.2114 45.707 23.3857C46.3195 24.2985 46.3195 25.8296 45.4008 27.6552C44.7883 28.8919 43.5604 29.5102 42.3355 29.8047C39.5765 23.3855 40.8043 19.3807 43.8666 17.8496C42.9479 15.7 42.948 15.1113 42.948 15.1113C42.948 15.1113 49.0785 16.024 50.9159 15.7001C53.675 15.1112 57.659 15.7001 59.1902 19.3808C61.643 20.3231 62.5617 21.8541 62.8679 23.6797C63.1771 26.1237 61.643 28.8922 61.3367 30.1289Z'
					fill='#0057B2'
				/>
				<path
					d='M58.9078 46.0487V47.2263H45.0684V45.754C45.3628 45.4595 45.3628 44.8709 45.3628 44.5764V38.9821L45.0684 38.6873V38.3926C45.3628 38.9815 45.6573 39.2759 46.2462 39.8649L50.6631 42.8094C51.5464 43.6928 53.0187 43.6928 54.1965 42.8094L58.3189 39.2761L58.6134 38.9821C58.6134 39.2765 58.6134 40.1599 58.6134 44.8712C58.3189 45.1656 58.6134 45.7543 58.9078 46.0487Z'
					fill='url(#paint0_linear_5627_65493)'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_5627_65493'
					x1='51.991'
					y1='47.2557'
					x2='51.991'
					y2='42.3972'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='white' />
					<stop offset='1' stopColor='#BCD5EA' />
				</linearGradient>
			</defs>
		</SvgIcon>
	);
};
